var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDecreaseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5068 5.06135C10.7485 5.06135 10.9443 5.25722 10.9443 5.49885L10.9443 10.5063C10.9443 10.6224 10.8982 10.7337 10.8162 10.8157C10.7341 10.8977 10.6229 10.9438 10.5068 10.9438L5.49934 10.9438C5.25772 10.9438 5.06184 10.748 5.06184 10.5063C5.06184 10.2647 5.25772 10.0688 5.49934 10.0688L10.0693 10.0688L10.0693 5.49885C10.0693 5.25722 10.2652 5.06135 10.5068 5.06135Z",
    fill: "#EE201C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18478 3.18485C3.35564 3.01399 3.63265 3.01399 3.8035 3.18485L10.7455 10.1269C10.9164 10.2977 10.9164 10.5747 10.7455 10.7456C10.5747 10.9164 10.2977 10.9164 10.1268 10.7456L3.18478 3.80357C3.01393 3.63271 3.01393 3.3557 3.18478 3.18485Z",
    fill: "#EE201C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecreaseIcon);
export default __webpack_public_path__ + "static/media/decrease-icon.8b4525eb050346ecc3d66f6e8a6c3d82.svg";
export { ForwardRef as ReactComponent };